var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"per-page-select",attrs:{"label":"Rows per page","items":_vm.options,"value":_vm.currentPerPageCount},on:{"change":_vm.setCountPerPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }